import cx from 'classnames';
import React from 'react';
export const FormItem = ({ children, className, density, disabled, error, indentation, wrapperRef, ...rest }) => (React.createElement("div", { className: cx('tds-form-item', {
        [`tds-density--${density}`]: density,
        'tds--disabled': disabled,
        [`tds-form--${indentation}`]: indentation,
        'tds-form--error': error,
    }, className), ref: wrapperRef, ...rest }, children));
